import axios from "../../config/axiosConfig";
import {
  PURCHASE_ORDER_REGISTER_REPORT_REQUEST,
  PURCHASE_ORDER_REGISTER_REPORT_SUCCESS,
  PURCHASE_ORDER_REGISTER_REPORT_FAILURE
} from "../types/purchase-order-report-types";

export const getPurchaseOrderRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_ORDER_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      // console.log('params.book_ids',params);
      console.log('params.fromDate',params?.fromDate);
      console.log('params.toDate',params?.toDate);
      
      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };
      const data = requestParams; 

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/purchase-order/getReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.post('/purchase-order/getReport', data,  { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_ORDER_REGISTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: PURCHASE_ORDER_REGISTER_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: PURCHASE_ORDER_REGISTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearPurchaseOrderRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: PURCHASE_ORDER_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}
